export interface PathNode {
  path: string;
  value: any;
  type: 'object' | 'array' | 'primitive';
  children?: PathNode[];
  parent?: string;
}

export function extractJsonPaths(obj: any, prefix: string = ''): PathNode[] {
  const paths: PathNode[] = [];
  
  function traverse(current: any, currentPath: string, parent?: string): PathNode {
    const node: PathNode = {
      path: currentPath,
      value: current,
      type: Array.isArray(current) ? 'array' : typeof current === 'object' && current !== null ? 'object' : 'primitive',
      parent
    };

    if (Array.isArray(current)) {
      node.children = current.map((item, index) => 
        traverse(item, `${currentPath}[${index}]`, currentPath)
      );
    } else if (typeof current === 'object' && current !== null) {
      node.children = Object.keys(current).map(key => 
        traverse(current[key], currentPath === '' ? key : `${currentPath}.${key}`, currentPath)
      );
    }

    return node;
  }

  if (typeof obj === 'object' && obj !== null) {
    if (Array.isArray(obj)) {
      obj.forEach((item, index) => {
        paths.push(traverse(item, `[${index}]`));
      });
    } else {
      Object.keys(obj).forEach(key => {
        paths.push(traverse(obj[key], key));
      });
    }
  } else {
    paths.push(traverse(obj, ''));
  }

  return paths;
}

export function validateJson(jsonString: string): { isValid: boolean; error?: string; parsed?: any } {
  try {
    const parsed = JSON.parse(jsonString);
    return { isValid: true, parsed };
  } catch (error) {
    return { 
      isValid: false, 
      error: error instanceof Error ? error.message : 'Invalid JSON format' 
    };
  }
}

export function flattenPaths(nodes: PathNode[]): string[] {
  const paths: string[] = [];
  
  function collectPaths(node: PathNode) {
    paths.push(node.path);
    if (node.children) {
      node.children.forEach(collectPaths);
    }
  }
  
  nodes.forEach(collectPaths);
  return paths;
}